module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"selected_period":"選択期間","compared_period":"比較期間","filter":"フィルタ","ok":"オーケー","cancel":"キャンセル","from":"から","to":"まで"}}')
  delete Component.options._Ctor
}
